module.exports = __webpack_public_path__ + "196bfa04b65ed0c3baf1920b5ed52559.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/test-step-8.svg
// module id = 492
// module chunks = 0